import { render } from "./LockItInAddToCart.vue?vue&type=template&id=2d24fbc6&scoped=true"
import script from "./LockItInAddToCart.vue?vue&type=script&lang=js"
export * from "./LockItInAddToCart.vue?vue&type=script&lang=js"

import "./LockItInAddToCart.vue?vue&type=style&index=0&id=2d24fbc6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d24fbc6"]])

export default __exports__